import type { FC, PropsWithChildren } from 'react';
import { useDragAndDrop } from './hooks/useDragAndDrop';
import { scrollingListStyle } from './NewHomesListings.styles.css';

export const DraggableList: FC<PropsWithChildren> = ({ children, ...rest }) => {
    const { refDraggableElement } = useDragAndDrop<HTMLUListElement>({
        dragAxis: 'x'
    });

    return (
        <ul className={scrollingListStyle} ref={refDraggableElement} {...rest}>
            {children}
        </ul>
    );
};
